module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/related/en/6-a0fc0db8dea443e472f48b81f5560fe9.jpg";